var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurgery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M8.439,21.042l-0.734,3.634l2.458,0.736 l1.518-0.544l1.452-0.557l0.194-2.788c0,0-1.586-0.46-1.625-0.46c-0.04,0-1.414-0.156-1.414-0.156L8.439,21.042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M24.559,21.056l0.734,3.634l-2.458,0.736 l-1.518-0.544l-1.452-0.557l-0.194-2.788c0,0,1.586-0.46,1.625-0.46c0.04,0,1.414-0.156,1.414-0.156L24.559,21.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BEFD0",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M10.646,27.235l-0.045,1.204h11.064 l-0.345-7.042l3.857-0.132c-0.809-3.58-2.057-5.707-2.057-5.707c-1.968-1.526-6.727-1.896-6.727-1.896 c-3.923,0.548-6.113,1.896-6.113,1.896c-1.803,2.107-2.487,6.103-2.487,6.103l3.725,0.502L10.646,27.235z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M14.832,11.633 c0.208,0.044,0.42,0.067,0.634,0.063c0.908-0.016,1.756-0.147,2.582-0.421c0.083,1.235,0.438,2.638,0.724,3.211 c0.56,1.121-2.558,1.052-2.558,1.052s-2.681-0.076-1.956-1.136C14.913,13.443,14.806,11.968,14.832,11.633z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161B43"
    },
    d: "M17.291,12.724c-0.528,0.196-1.086,0.185-1.616,0.013c-0.366-0.119-0.641-0.367-0.894-0.548 c0.137-0.7,0.055-0.61,0.055-0.61l3.118-2.509c0,0,0,1.568,0.182,3.172C17.865,12.477,17.878,12.506,17.291,12.724z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12.703,8.681 c-0.008-0.592,0.17-1.075,0.543-1.08c0.065-0.001,0.131,0.014,0.196,0.04c-0.013-0.165-0.022-0.285-0.026-0.335 c-0.002-0.02-0.002-0.039-0.002-0.059c0-0.004,0-0.01,0-0.014c0,0,0,0,0,0c0-0.01,0.001-0.022,0.001-0.036 c0-0.005,0-0.01,0.001-0.015c0-0.011,0.001-0.023,0.002-0.035c0.001-0.009,0.001-0.019,0.002-0.029 c0.001-0.011,0.002-0.022,0.002-0.033c0.001-0.013,0.002-0.027,0.003-0.041c0.001-0.011,0.002-0.022,0.003-0.034 c0.002-0.017,0.004-0.034,0.006-0.052c0.001-0.011,0.002-0.021,0.004-0.032c0.002-0.02,0.005-0.042,0.008-0.063 c0.001-0.01,0.003-0.02,0.004-0.031c0.003-0.023,0.007-0.048,0.011-0.073c0.002-0.01,0.003-0.019,0.005-0.029 c0.004-0.027,0.01-0.054,0.015-0.082c0.002-0.009,0.003-0.019,0.005-0.028C13.493,6.589,13.5,6.56,13.506,6.53 c0.002-0.009,0.004-0.019,0.006-0.028c0.007-0.031,0.015-0.063,0.023-0.095c0.002-0.009,0.004-0.018,0.007-0.027 c0.009-0.033,0.018-0.067,0.028-0.101c0.003-0.009,0.005-0.018,0.008-0.027c0.01-0.034,0.021-0.069,0.033-0.104 c0.003-0.009,0.006-0.018,0.009-0.027c0.012-0.035,0.025-0.071,0.038-0.107c0.003-0.009,0.007-0.018,0.01-0.027 c0.014-0.036,0.029-0.072,0.044-0.109c0.004-0.009,0.007-0.018,0.011-0.027c0.016-0.036,0.033-0.073,0.05-0.11 c0.004-0.009,0.009-0.018,0.013-0.028c0.018-0.036,0.037-0.073,0.056-0.109c0.005-0.009,0.01-0.019,0.015-0.028 c0.02-0.036,0.041-0.072,0.063-0.108c0.006-0.01,0.011-0.019,0.017-0.029c0.022-0.035,0.045-0.07,0.069-0.105 c0.007-0.01,0.013-0.02,0.02-0.03c0.024-0.034,0.05-0.068,0.076-0.102c0.008-0.01,0.015-0.02,0.023-0.03 c0.026-0.033,0.054-0.065,0.082-0.098c0.009-0.01,0.017-0.02,0.026-0.031c0.028-0.031,0.058-0.062,0.089-0.093 c0.01-0.01,0.02-0.021,0.03-0.031c0.03-0.03,0.062-0.058,0.095-0.087c0.012-0.01,0.023-0.021,0.035-0.031 c0.032-0.028,0.067-0.054,0.101-0.08c0.013-0.01,0.026-0.021,0.04-0.031c0.035-0.025,0.071-0.05,0.108-0.074 c0.015-0.01,0.029-0.02,0.045-0.03c0.037-0.023,0.076-0.045,0.115-0.067c0.017-0.01,0.033-0.02,0.051-0.029 c0.039-0.021,0.08-0.04,0.121-0.059c0.019-0.009,0.037-0.019,0.057-0.027c0.041-0.018,0.085-0.035,0.128-0.051 c0.021-0.008,0.041-0.017,0.063-0.025C15.355,4.314,15.4,4.3,15.445,4.286c0.024-0.008,0.047-0.016,0.072-0.023 c0.046-0.013,0.094-0.023,0.141-0.034c0.026-0.006,0.051-0.013,0.078-0.018c0.049-0.01,0.101-0.018,0.151-0.026 c0.028-0.004,0.054-0.01,0.083-0.014c0.054-0.007,0.111-0.012,0.168-0.018c0.027-0.003,0.053-0.006,0.081-0.008 c0.085-0.006,0.173-0.01,0.264-0.011c0.088-0.001,0.173,0,0.256,0.004c0.027,0.001,0.053,0.004,0.08,0.006 c0.055,0.004,0.109,0.007,0.162,0.013c0.03,0.003,0.059,0.008,0.089,0.012c0.047,0.006,0.094,0.012,0.139,0.02 c0.03,0.005,0.059,0.011,0.089,0.017c0.043,0.009,0.085,0.017,0.126,0.027c0.029,0.007,0.057,0.015,0.085,0.022 c0.04,0.011,0.079,0.022,0.118,0.034c0.027,0.009,0.053,0.017,0.079,0.026c0.038,0.013,0.075,0.027,0.111,0.041 c0.024,0.01,0.049,0.019,0.073,0.03c0.036,0.015,0.072,0.032,0.107,0.048c0.022,0.01,0.044,0.021,0.065,0.032 c0.036,0.018,0.07,0.038,0.105,0.057c0.018,0.01,0.037,0.021,0.055,0.032c0.037,0.022,0.072,0.045,0.107,0.069 c0.014,0.009,0.028,0.018,0.042,0.028c0.043,0.03,0.084,0.061,0.124,0.093c0.005,0.004,0.01,0.007,0.014,0.011 c0.09,0.073,0.173,0.151,0.25,0.231c0.007,0.008,0.014,0.016,0.021,0.023c0.03,0.032,0.059,0.065,0.087,0.098 c0.009,0.011,0.018,0.023,0.028,0.034c0.024,0.03,0.049,0.061,0.071,0.091c0.01,0.013,0.019,0.026,0.028,0.039 c0.021,0.03,0.042,0.059,0.062,0.09c0.009,0.014,0.018,0.027,0.027,0.041c0.019,0.03,0.038,0.06,0.055,0.09 c0.008,0.014,0.016,0.028,0.024,0.041c0.017,0.03,0.034,0.061,0.05,0.091c0.007,0.014,0.014,0.027,0.021,0.041 c0.016,0.031,0.031,0.062,0.046,0.093c0.006,0.013,0.012,0.025,0.018,0.038c0.015,0.033,0.029,0.066,0.043,0.098 c0.004,0.011,0.009,0.021,0.013,0.032c0.015,0.036,0.029,0.073,0.042,0.109c0.002,0.006,0.005,0.013,0.007,0.019 c0.032,0.087,0.059,0.172,0.083,0.253c0.001,0.002,0.001,0.004,0.002,0.006c0.011,0.038,0.021,0.075,0.03,0.111 c0.003,0.011,0.005,0.021,0.008,0.032c0.007,0.027,0.013,0.054,0.019,0.08c0.003,0.014,0.006,0.027,0.009,0.041 c0.005,0.022,0.009,0.043,0.014,0.064c0.003,0.015,0.006,0.029,0.008,0.044c0.003,0.018,0.007,0.037,0.01,0.055 c0.003,0.015,0.005,0.03,0.007,0.045c0.003,0.015,0.005,0.03,0.007,0.044c0.002,0.016,0.005,0.032,0.007,0.047 c0.002,0.011,0.003,0.022,0.004,0.033c0.002,0.016,0.004,0.032,0.006,0.047c0.001,0.008,0.002,0.015,0.003,0.022 c0.002,0.017,0.004,0.034,0.005,0.049c0,0,0,0.001,0,0.001l0,0c0.006,0.06,0.009,0.107,0.01,0.135c0.001,0.02,0.001,0.039,0,0.059 c-0.002,0.05-0.008,0.17-0.017,0.336c0.065-0.028,0.131-0.044,0.195-0.045c0.373-0.005,0.563,0.473,0.571,1.065 c0.007,0.561-0.554,1.028-0.93,1.08c-0.063,0.558-0.158,1.036-0.241,1.237c-0.363,0.882-1.704,1.584-2.595,1.596 c-0.891,0.012-1.968-0.449-2.682-1.526c-0.12-0.181-0.196-0.675-0.273-1.231C13.283,9.695,12.71,9.243,12.703,8.681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4BA0A0"
    },
    d: "M19.504,14.37c-0.037-0.008-0.074-0.017-0.11-0.029c-0.017-0.006-0.033-0.014-0.049-0.021 c-0.001,0-0.001,0-0.002,0c-0.008,0-0.016-0.004-0.024-0.007c-0.001,0-0.002,0-0.004,0c0.002,0.001,0.005,0.002,0.007,0.003 c-0.004-0.002-0.009-0.003-0.014-0.003c-0.006,0-0.013-0.001-0.019-0.001c-0.01-0.001-0.021-0.003-0.032-0.005 c0.208,0.339,0.253,0.632,0.127,0.869c-0.53,0.998-3.679,0.916-3.714,0.915c-1.101,0.002-1.79-0.222-1.992-0.649 c-0.216-0.455,0.165-1.03,0.233-1.126c-0.022,0.006-0.045,0.011-0.067,0.02c-0.001,0.001-0.003,0.001-0.004,0.002 c-0.008,0.004-0.016,0.007-0.023,0.011c-0.014,0.007-0.029,0.014-0.044,0.021c-0.047,0.022-0.095,0.039-0.144,0.051 c-0.141,0.265-0.305,0.707-0.117,1.104c0.238,0.504,0.964,0.759,2.155,0.756c0.027,0.001,0.172,0.005,0.394,0.002 c0.893-0.012,3.016-0.134,3.484-1.015C19.684,15.007,19.668,14.705,19.504,14.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M14.163,6.559c0,0-0.26,1.137-0.221,2.583l-0.59-1.433c0,0-0.408-0.545,0.039-0.827l0.406-0.493 l0.187-0.028l0.113,0.036L14.163,6.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M18.862,6.357c0,0,0.283,1.294,0.243,2.706l0.598-1.578c0,0,0.393-0.556-0.061-0.825l-0.42-0.483 l-0.188-0.023l-0.112,0.039L18.862,6.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BEFD0",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.414,6.895c0,0,2.264-1.596,6.118-0.22 c0,0,1.258-1.635,0.125-2.922c-1.133-1.287-4.264-0.78-4.264-0.78S11.213,3.283,13.414,6.895z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M14.474,13.971l0.144-0.381l-0.153,0.03c-0.583,0.149-1.032,0.491-1.335,1.017 c-0.951,1.648-0.151,4.554-0.116,4.677l0.359-0.101c-0.008-0.029-0.792-2.879,0.081-4.391c0.237-0.41,0.568-0.675,1.014-0.813 c0.002-0.006,0.002-0.013,0.004-0.018c-0.001,0.003-0.003,0.007-0.004,0.011C14.47,13.992,14.472,13.982,14.474,13.971z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M12.873,23.894c-0.308-0.426-0.543-1.025-0.63-1.695c-0.177-1.37,0.321-2.611,1.088-2.71 c0.767-0.099,1.565,0.974,1.742,2.344c0.093,0.721-0.001,1.407-0.223,1.909c0.092,0.08,0.176,0.171,0.247,0.271 c0.292-0.566,0.417-1.358,0.305-2.222c-0.207-1.601-1.135-2.757-2.113-2.631c-0.978,0.126-1.582,1.48-1.375,3.082 c0.102,0.791,0.381,1.473,0.754,1.945C12.723,24.081,12.793,23.983,12.873,23.894z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M12.753,20.043l-0.532-0.319c0.014-0.023,0.342-0.564,0.945-0.693 c0.384-0.082,0.779,0.017,1.173,0.293l-0.357,0.508c-0.246-0.173-0.476-0.238-0.683-0.195 C12.963,19.707,12.755,20.04,12.753,20.043z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M18.344,21.4l-0.334-0.164l0.897-1.83c0.013-0.029,1.498-3.29,0.743-4.727 c-0.181-0.344-0.62-0.545-1.043-0.618l-0.127-0.424c0.537,0.093,1.264,0.422,1.499,0.869c0.84,1.599-0.672,4.919-0.736,5.06 L18.344,21.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M18.778,21.993c-0.03-0.339-0.245-0.65-0.583-0.785c-0.338-0.135-0.707-0.058-0.963,0.167 L18.778,21.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M16.457,7.856l0.483,1.575 c0,0,0.044,0.36-0.284,0.382h-0.518"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2"
    },
    d: "M17.412,10.643c0.104,0.069,0.204,0.139,0.196,0.246c-0.012,0.169-0.035,0.401-0.067,0.423 c-0.024,0.016-0.137,0.034-0.251,0.049c-0.151,0.019-0.298-0.044-0.355-0.153l-0.013-0.025c-0.022-0.041-0.072-0.066-0.127-0.063 l-0.499,0.027c-0.048,0.003-0.09,0.026-0.111,0.061l0,0c-0.073,0.12-0.247,0.18-0.407,0.141c-0.094-0.023-0.178-0.048-0.191-0.07 c-0.02-0.034,0.007-0.295,0.029-0.478c0.013-0.108,0.111-0.2,0.246-0.23C16.09,10.521,17.029,10.389,17.412,10.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M15.988,10.847c0,0,0.753,0.306,1.223-0.044"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 11.478,
    y1: 22.935,
    x2: 11.686,
    y2: 18.209
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 21.247,
    y1: 22.935,
    x2: 21.455,
    y2: 18.209
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M21.291,19.986l1.287-2.421 c0,0,0.613,0.445,0.162,1.091l-0.443,0.779l-0.32,0.206l-0.386,0.782l-0.28,0.346l-0.17-0.247L21.291,19.986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M21.328,19.62l-2.049,3.873 c-0.053,0.101-0.015,0.226,0.086,0.279l0.286,0.151c0.101,0.053,0.226,0.015,0.279-0.086l1.928-3.645L21.328,19.62z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M8.177,23.542L8.177,23.542 c-0.661,0.948-0.7,2.197-0.098,3.184c0.749,1.23,1.666,0.866,3.661,0.57l7.339-1.597c0.209-0.087,0.323-0.313,0.269-0.533 L18.43,21.45l-9.512,1.627C8.618,23.125,8.351,23.293,8.177,23.542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M14.966,21.48c0,0-2.03-0.573-2.691-0.272 c-0.661,0.3-1.381,1.509-1.381,1.509s2.019,0.37,3.289,1.011L14.966,21.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M18.106,21.737c0,0,2.03-0.573,2.691-0.272 c0.661,0.301,1.381,1.509,1.381,1.509s-2.02,0.37-3.289,1.011L18.106,21.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M24.86,23.165L24.86,23.165 c0.661,0.948,0.699,2.197,0.098,3.184c-0.749,1.23-1.666,0.866-3.661,0.57l-7.338-1.597c-0.209-0.087-0.323-0.313-0.269-0.533 l0.917-3.716l9.512,1.627C24.419,22.749,24.687,22.916,24.86,23.165z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgery);
export default __webpack_public_path__ + "static/media/surgery.223688c2d30518ef5bba8dbc6c7e0fef.svg";
export { ForwardRef as ReactComponent };